import { $body } from '../Constants';
import HelperUtility from '../Utility/HelperUtility';

/**
 * Headline Service
 */
const HeadlineService = (() => {
  /**
   * This headlines will be checked for prev and next elements
   *
   * @var { Array }
   */
  const HEADLINES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

  /**
   * Class Name
   *
   * @var { Object }
   */
  const ClassName = {
    'PREV': '-prev',
    'NEXT': '-next'
  };

  /**
   * Headline Service
   *
   * @class
   */
  class HeadlineService {
    /**
     * @constructor
     */
    constructor() {
      this._selectors = this._getSelectors();
    }

    // Public

    /**
     * Initialize
     *
     * @return void
     */
    initialize() {
      $body.find(this._selectors).each((i, el) => {
        let $headline = $(el);
        let $prevElement = $headline.prev(this._selectors);
        let $nextElement = $headline.next(this._selectors);

        if ($prevElement.length > 0) {
          this._addPrevClass($headline, $prevElement);
        } else {
          $headline.addClass('no-prev');
        }

        if ($nextElement.length > 0) {
          this._addNextClass($headline, $nextElement);
        } else {
          $headline.addClass('no-next');
        }
      });
    }

    // Private

    /**
     * Gets the selectors with and without the class names
     *
     * @return { String } selectors
     */
    _getSelectors() {
      let selectors = '';

      HEADLINES.forEach((headline, i) => {
        if (i > 0) {
          selectors += ', ';
        }

        selectors += `${headline}, .${headline}`;
      });

      return selectors;
    }

    /**
     * Adds the '-prev' classes
     *
     * @param { jQuery } $headline
     * @param { jQuery } $prevElement
     * @return void
     */
    _addPrevClass($headline, $prevElement) {
      let headlineIndex = HEADLINES.indexOf($prevElement.prop('tagName').toLowerCase());

      if (headlineIndex > -1) {
        $headline.addClass(`${HEADLINES[headlineIndex]}${ClassName.PREV}`);
      } else {
        let classIndex = HelperUtility.hasOneOfClasses($prevElement.get(0), HEADLINES);

        if (classIndex > -1) {
          $headline.addClass(`${HEADLINES[classIndex]}${ClassName.PREV}`);
        }
      }
    }

    /**
     * Adds the '-next' classes
     *
     * @param { jQuery } $headline
     * @param { jQuery } $nextElement
     * @return void
     */
    _addNextClass($headline, $nextElement) {
      let headlineIndex = HEADLINES.indexOf($nextElement.prop('tagName').toLowerCase());

      if (headlineIndex > -1) {
        $headline.addClass(`${HEADLINES[headlineIndex]}${ClassName.NEXT}`);
      } else {
        let classIndex = HelperUtility.hasOneOfClasses($nextElement.get(0), HEADLINES);

        if (classIndex > -1) {
          $headline.addClass(`${HEADLINES[classIndex]}${ClassName.NEXT}`);
        }
      }
    }
  }

  return (new HeadlineService);
})();

export default HeadlineService;
